class ProductUsagePersona {
    constructor({ persona }) {
        this.persona = persona;
    }
}
ProductUsagePersona.Default = new ProductUsagePersona({ persona: 'default' });
ProductUsagePersona.Paid = new ProductUsagePersona({ persona: 'paid' });
ProductUsagePersona.DiscoActivated = new ProductUsagePersona({ persona: 'disco-activated' });
ProductUsagePersona.DiscoNotActivated = new ProductUsagePersona({ persona: 'disco-not-activated' });
ProductUsagePersona.DiscoNotAcquired = new ProductUsagePersona({ persona: 'disco-not-acquired' });
ProductUsagePersona.Disco = new ProductUsagePersona({ persona: 'disco' });
ProductUsagePersona.Free = new ProductUsagePersona({ persona: 'free' });
ProductUsagePersona.Education = new ProductUsagePersona({ persona: 'education' });
ProductUsagePersona.Expired = new ProductUsagePersona({ persona: 'expired' });
export default ProductUsagePersona;
